import { useState } from "react";

const FORM_SUBMIT_URL = "https://readdy.ai/api/form/d9oqkkiftmtnfcfh0cc0";

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formMessage, setFormMessage] = useState("");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const phoneAlt = formData.get("phone_alt") as string;
    if (phoneAlt && phoneAlt.trim() !== "") {
      setFormStatus("success");
      setFormMessage("提交成功，我们会尽快回复您！");
      form.reset();
      setCharCount(0);
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== "phone_alt") {
        payload.append(key, value as string);
      }
    });

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setFormStatus("success");
        setFormMessage("提交成功，我们会尽快回复您！");
        form.reset();
        setCharCount(0);
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || "提交失败，请稍后重试";
        setFormStatus("error");
        setFormMessage(serverMsg);
      }
    } catch {
      setFormStatus("error");
      setFormMessage("网络错误，请检查连接后重试");
    }
  };

  return (
    <section className="py-8 md:py-10" id="contact">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-5">
        联系我们
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
        <div>
          <p className="text-foreground-600 text-sm leading-relaxed mb-5">
            如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们，或直接填写右侧表单，我们会在24小时内回复您。
          </p>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-rose-50 flex-shrink-0">
                <i className="ri-mail-line text-rose-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">
                  电子邮箱
                </h4>
                <p className="text-sm text-foreground-600">contact@51chigua.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-rose-50 flex-shrink-0">
                <i className="ri-customer-service-line text-rose-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">
                  客服热线
                </h4>
                <p className="text-sm text-foreground-600">400-888-5151</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-rose-50 flex-shrink-0">
                <i className="ri-time-line text-rose-500"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900">
                  工作时间
                </h4>
                <p className="text-sm text-foreground-600">
                  周一至周五 9:00 - 18:00
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-background-50 rounded-lg border border-background-200/60">
            <h4 className="text-sm font-semibold text-foreground-900 mb-2">
              内容合作
            </h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              如果您是内容创作者或有优质内容资源，欢迎与我们洽谈合作。51吃瓜网致力于为优质内容提供展示平台，期待与您携手共创精彩。
            </p>
          </div>
        </div>

        <div>
          <form
            onSubmit={handleSubmit}
            className="space-y-4 bg-background-50 rounded-lg border border-background-200/60 p-5"
            data-readdy-form
          >
            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                您的姓名 <span className="text-rose-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                required
                className="w-full px-3 py-2.5 border border-background-200/60 rounded-lg text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-rose-300 transition-colors"
                placeholder="请输入您的姓名"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                电子邮箱 <span className="text-rose-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                className="w-full px-3 py-2.5 border border-background-200/60 rounded-lg text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-rose-300 transition-colors"
                placeholder="请输入您的邮箱"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容 <span className="text-rose-500">*</span>
              </label>
              <textarea
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-3 py-2.5 border border-background-200/60 rounded-lg text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-rose-300 transition-colors resize-none"
                placeholder="请输入您的留言内容（最多500字）"
                onChange={(e) => setCharCount(e.target.value.length)}
              ></textarea>
              <p className="text-xs text-foreground-500 mt-1 text-right">
                {charCount}/500
              </p>
            </div>

            <div className="phone-alt-container">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>

            <button
              type="submit"
              className="w-full py-2.5 bg-rose-500 hover:bg-rose-600 text-white font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              提交留言
            </button>

            {formStatus !== "idle" && (
              <div
                className={`p-3 rounded-lg text-sm ${
                  formStatus === "success"
                    ? "bg-green-50 text-green-700 border border-green-200"
                    : "bg-red-50 text-red-700 border border-red-200"
                }`}
              >
                {formMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}